import { JetView } from 'webix-jet';
import {
    devConfig, // Configuration for development
    countries, // List of countries
    providersCasino, // List of casino providers
    gamesCasino, // List of casino games
    profile, // User profile information
    machines, // List of machines
} from 'config/config';

/**
 * Class representing the filter view for machine products.
 * @extends JetView
 */
export default class FilterMachineProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size
        const cur_user = this.getParam('user', true); // Current user parameter

        // Left section containing provider and machine reference filters
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo', // Dropdown for selecting provider
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'), // Label for the provider combo
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Fetch provider data based on input
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Dropdown for selecting machine reference
                            name: 'MachineReference',
                            label: _('Máquina Referencia'), // Label for the machine reference combo
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Fetch machine data based on input
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/MachinesSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        };

        // Left section containing additional filters
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for verification status
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for country filter
                            name: 'FilterCountry',
                            label: "<span class='icon-language'></span>" + _('Filtro País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text', // Input for maximum value
                            name: 'Maximum',
                            type: 'number',
                            label: _('Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Máximo'),
                            invalidMessage: _('Máximo is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for minimum value
                            name: 'Minimum',
                            type: 'number',
                            label: _('Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Mínimo'),
                            invalidMessage: _('Mínimo is required'), // Validation message
                        },
                        {
                            view: 'text', // Input for processing time
                            name: 'ProcessingTime',
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'),
                            invalidMessage: _(
                                'Tiempo Procesamiento is required', // Validation message
                            ),
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section containing the first set of filters
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section containing the second set of filters
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 320 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons for clearing and consulting filters
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                filterdata.IdMachine = cur_user; // Add current user to filter data
                                this.app.callEvent('machineProvider:filter', [
                                    filterdata, // Trigger filter event
                                ]);
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for basic filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for basic filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements based on screen size
            }
        });
    }
}

// FILE DOCUMENTED
